import React from 'react';

import emptyLikeImage from '../../public/images/empty_like.png';
import filledLikeImage from '../../public/images/filled_like.png';
import emptyStarImage from '../../public/images/empty_star.png';
import filledStarImage from '../../public/images/filled_star.png';
import bookmarkEditIcon from '../../public/images/bookmark_edit_icon.png';



const DashboardHeader = (props) => {
    return (
        <div className="d-flex">
            <h1 id="dashboard-title" className="head-title">{props?.title}</h1>
            <span className="bookmark_alignment">
                <img id="fav_button"  src={props.isDashboardLiked ? filledLikeImage : emptyLikeImage} className="fav-star" onClick={props.handleClickLike}/>
                <div data-toggle="tooltip" data-placement="top" title="Add this Dashboard to Favorites" >
                    <img id="bookmark_button"  src={props.isDashboardBookmarked ? filledStarImage : emptyStarImage} className="fav-star bookmark-icon" onClick={props.handleClickBookmark}/>
                </div>
                <div data-toggle="tooltip" data-placement="top" title="Bookmark this Dashboard">
                    <img id="update-bookmark-icon"  src={bookmarkEditIcon} className= {`fav-star update-bookmark-icon ${! props.isDashboardBookmarked && 'd-none'}`} style={{ color: 'white' }} onClick={props.handleClickBookmarkEdit}/>
                </div>
            </span>
        </div>
    );
};

export default DashboardHeader;
